export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/BR-5730493f536fca3afdfb64833a4bd7ed.png";